// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4559d120","453":"7fe73161","732":"032df558"}[chunkId] + ".chunk.js";
};